module.exports = __webpack_public_path__ + "static/img/businessCard-example.8f7adba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/businessCard-example.png
// module id = o2Bc
// module chunks = 1